var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 18.859,
    viewBox: "0 0 20 18.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.619,
    y1: 0.054,
    x2: 0.855,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537b9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#365d7e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M16.439,32.411a1.147,1.147,0,0,1-1.14,1.14H12.14A1.138,1.138,0,0,1,11,32.411V23.459a1.138,1.138,0,0,1,1.14-1.14h3.143a1.138,1.138,0,0,1,1.14,1.14Zm13.374-7.026a1.567,1.567,0,0,1,.247,2.2,1.511,1.511,0,0,1-.863.539,1.55,1.55,0,0,1,.247,2.188,1.6,1.6,0,0,1-.878.555,1.571,1.571,0,0,1-.986,2.789l-8.859-.092a1.138,1.138,0,0,1-1.14-1.14V23.459c0-1.417,4.53-4.021,4.761-5.423.154-.924-.046-3.236.57-3.236,1.063,0,2.4.4,2.4,2.743a13.14,13.14,0,0,1-1.356,4.745h5.485A1.552,1.552,0,0,1,31,23.844a1.5,1.5,0,0,1-1.186,1.541Z",
    transform: "translate(-11 -14.8)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.3727520dd00b8e63537d8e9acd4ac47b.svg";
export { ForwardRef as ReactComponent };